import { render, staticRenderFns } from "./NarrativeBuilder.vue?vue&type=template&id=b003878c&scoped=true&"
import script from "./NarrativeBuilder.vue?vue&type=script&lang=js&"
export * from "./NarrativeBuilder.vue?vue&type=script&lang=js&"
import style0 from "./NarrativeBuilder.vue?vue&type=style&index=0&id=b003878c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b003878c",
  null
  
)

export default component.exports